module.exports = "//static.hsappstatic.net/marketplace-ui-common/static-1.10836/img/callout-blobs.svg"